<div class="rl-success-dialog">
  <button class="close-x" (click)="close()">✕</button>

  <div class="art">
    <!-- simple concentric rings with check -->
    <svg viewBox="0 0 220 220" class="rings" xmlns="http://www.w3.org/2000/svg">
      <circle cx="110" cy="110" r="100" fill="#EAF9EA"/>
      <circle cx="110" cy="110" r="78" fill="#CFF5C9"/>
      <circle cx="110" cy="110" r="56" fill="#7DE06A"/>
      <g transform="translate(0,0)">
        <polyline points="82,110 100,128 138,90" fill="none" stroke="#fff" stroke-width="8" stroke-linecap="round" stroke-linejoin="round"/>
      </g>
    </svg>
  </div>

  <h2 class="title">{{ title }}</h2>
  <p class="desc">{{ desc }}</p>
</div>
